import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { UserPermissionForm } from '../Forms';
import { Text1 } from '../../../styles';


const PermissionModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Permissions
            </Text1>
        )
    };

    return (
        <EaseModal
            width={950}
            title={false}
            visible={props.visible}
            onCancel={props.togglePermissionModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <UserPermissionForm
                user={props.user}
                users={props.users}
                cloneUsers={props.cloneUsers}
                is_reseller={props.is_reseller}
                permissions={props.permissions}
                onSubmit={props.setUserPermission}
                loading={props.loading}
            />
        </EaseModal>
    )
};

PermissionModal.defaultProps = {
    user: {}
};

export { PermissionModal };